import { Box, Divider, Grid, Typography } from "@mui/material";
import { useCallback } from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { info, error, mint, secondary, purple, success } from "../../../../theme/colors";
import { UpcomingSlots } from "../services/entity";
import dayjs from "dayjs";
var renderTooltip = function (props) {
    var payload = props.payload, label = props.label;
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: secondary[900],
        maxWidth: 150,
        fontSize: "sm",
        rowSpacing: 0.5,
        px: 1.5,
        py: 0.5,
        color: "white",
        borderRadius: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        textAlign: "center",
        fontSize: "xs"
    }, dayjs(label).set('year', dayjs().year()).format('dddd, DD MMM'), /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth",
        flexItem: true,
        sx: {
            my: 0.5,
            borderColor: '#585858'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        xs: 8
    }, "Slot"), /*#__PURE__*/ React.createElement(Grid, {
        xs: 4,
        textAlign: "right"
    }, "Count"), payload === null || payload === void 0 ? void 0 : payload.map(function (item) { return item.type !== 'none' && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        item: true,
        xs: 12,
        columnSpacing: 0.5
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        item: true,
        xs: 1,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Box, {
        height: 8,
        width: 8,
        borderRadius: 0.5,
        bgcolor: item.color,
        flexGrow: 1,
        flexShrink: 0
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 7,
        wrap: "nowrap",
        flexWrap: "nowrap"
    }, item.name), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }, ":"), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        textAlign: "right"
    }, item.value)); }));
};
export default function UpcomingSlotsBarChart() {
    var total = UpcomingSlots.reduce(function (acc, it) { return acc + it.total_appointments; }, 0);
    var legendLabelFormatter = useCallback(function (value) { /*#__PURE__*/ return React.createElement("span", {
        style: {
            color: secondary[400],
            fontSize: 10
        }
    }, value); }, []);
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: 2,
            margin: "auto",
            border: "1px solid #e0e0e0",
            borderRadius: "4xl",
            backgroundColor: "#fff"
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "strong"
    }, "Upcoming Slots")), /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "secondary"
    }, "Total bookings"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 24,
        fontWeight: "strong"
    }, total))), /*#__PURE__*/ React.createElement(ResponsiveContainer, {
        width: "100%",
        height: 300
    }, /*#__PURE__*/ React.createElement(ComposedChart, {
        data: UpcomingSlots
    }, /*#__PURE__*/ React.createElement(XAxis, {
        dataKey: "date",
        fontSize: 12,
        tickLine: false
    }), /*#__PURE__*/ React.createElement(YAxis, {
        domain: [0, 45],
        tickCount: 4,
        tickLine: false,
        axisLine: false,
        width: 24,
        fontSize: 12
    }), /*#__PURE__*/ React.createElement(Legend, {
        verticalAlign: "top",
        formatter: legendLabelFormatter,
        iconSize: 20,
        wrapperStyle: {
            paddingBottom: 16
        }
    }), /*#__PURE__*/ React.createElement(CartesianGrid, {
        vertical: false
    }), /*#__PURE__*/ React.createElement(Tooltip, {
        cursor: false,
        content: renderTooltip
    }), /*#__PURE__*/ React.createElement(Bar, {
        name: "9am - 12pm",
        dataKey: function (obj) { return obj.timeslots["9:00 - 12:00 pm"]; },
        fill: info[500],
        barSize: 30,
        stackId: 'a'
    }), /*#__PURE__*/ React.createElement(Bar, {
        name: "12pm - 2pm",
        dataKey: function (obj) { return obj.timeslots["12:00 - 2:00 pm"]; },
        fill: purple[500],
        barSize: 30,
        stackId: 'a'
    }), /*#__PURE__*/ React.createElement(Bar, {
        name: "3pm - 5pm",
        dataKey: function (obj) { return obj.timeslots["3:00 - 5:00 pm"]; },
        fill: mint[500],
        barSize: 30,
        stackId: 'a'
    }), /*#__PURE__*/ React.createElement(Bar, {
        name: "5pm - 7pm",
        dataKey: function (obj) { return obj.timeslots["5:00 - 7:00 pm"]; },
        fill: success[500],
        barSize: 30,
        label: {
            position: 'top'
        },
        radius: [4, 4, 0, 0],
        stackId: 'a'
    }), /*#__PURE__*/ React.createElement(Line, {
        name: "Capacity",
        type: "linear",
        dataKey: "workshop_capacity",
        legendType: "none",
        tooltipType: "none",
        stroke: error[500],
        label: {
            position: 'top',
            fontSize: 11,
            fill: secondary[300]
        }
    }))));
}
